var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('next-steps-base-card',{attrs:{"title":"איך כדאי לחסוך לטווח קצר","button-text":"לצפייה בסרטונים","description":"10 דקות, סרטונים","action-key":_vm.actionKey},on:{"click":_vm.openSavingsVideo}})}
var staticRenderFns = []

export { render, staticRenderFns }